<template>
    <div class="ranking-bar" :style="{ width: barWidth + 'px' }">
        <div class="ranking-bar__fill" :style="{ width: fillWidth + 'px' }"></div>
    </div>
</template>



<script>
    export default {
        name: 'RankingBar',
        props: {
            percent: {
                type: Number,
                required: true, // 0–100
            },
            barWidth: {
                type: Number,
                default: 80,
            },
        },
        computed: {
            fillWidth() {
                const clamped = Math.max(0, Math.min(this.percent, 100));
                return Math.round((this.barWidth * clamped) / 100);
            },
        },
    };
</script>



<style scoped lang="scss">
    .ranking-bar {
        display: inline-flex;
        height: 1rem;
        background: #eee;
        border-radius: 4px;
        overflow: hidden;
    }

    .ranking-bar__fill {
        height: 100%;
        background: $primary;
    }
</style>
